import { AxiosInstance } from 'axios';
import {IResponse} from "app/app.types";
import {from, Observable} from "rxjs";
import {first, map} from "rxjs/operators";
import NetworkRequestsService from 'external-services/network-requests-service/index';
import { IBooking } from 'shared-types/index';
import DateUtilsService from 'external-services/date-utils-service';

const apiWithoutToken: AxiosInstance = NetworkRequestsService.getGlobalAPIWithoutToken();
const api: AxiosInstance = NetworkRequestsService.getGlobalAPI();

const NS = 'StandbyListService';

class StandbyListService {

  private APIBASE: string;
  private accountId: string;
  private venueId: number;

  setup(api: string, accountId: string, venueId: number): void {
    this.APIBASE = api;
    this.accountId = accountId;
    this.venueId = venueId;
  }

  beginStandbyPayment(bookingId: string, venueId: number): Observable<IResponse<string>> {
    return from(
      apiWithoutToken.get(`${this.APIBASE}/bookings/venues/${venueId}/begin-standby-payment/${bookingId}`)
    );
  }

  upgradeStandbyList(booking: IBooking): Observable<number> {
    const timeWithoutTZ = DateUtilsService.dateToDateTimeStr(booking.time);
    const data = {
      ...booking,
      time: timeWithoutTZ
    }

    return from(
      api.post(`${this.APIBASE}/restaurants/accounts/${this.accountId}/venues/${this.venueId}/upgrade-standby`, data)
    ).pipe(
      first(),
      map((response: IResponse<any>) => {
        // leaving this line here for easier breakpoint/debugging in dev tools
        return response.status;
      })
    );
  }

  getGenericErrorResponseMessaging(status: number): string {
    switch(status) {
      case 403:
        return 'Sorry, there seems to have been a problem authorizing your account.';

      case 400:
        return 'Sorry, there seems to have been a problem with either your account or booking id.'

      case 404:
        return `Sorry, your account id doesn't appear to match any of our records.`;

      case 408:
        return `Sorry, server took too long to respond (timeout).`;
    }

    return 'Sorry, an error has occurred.';
  }

}

// creates a singleton instance to export
const instance = new StandbyListService();
export { instance as StandbyListService };
